/* tslint:disable */

declare var Object: any;
export interface TicketCfdiInterface {
  "pedido": string;
  "uuid": string;
  "odooData": any;
  "id"?: any;
}

export class TicketCfdi implements TicketCfdiInterface {
  "pedido": string;
  "uuid": string;
  "odooData": any;
  "id": any;
  constructor(data?: TicketCfdiInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TicketCfdi`.
   */
  public static getModelName() {
    return "TicketCfdi";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TicketCfdi for dynamic purposes.
  **/
  public static factory(data: TicketCfdiInterface): TicketCfdi{
    return new TicketCfdi(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TicketCfdi',
      plural: 'TicketCfdis',
      path: 'TicketCfdis',
      idName: 'id',
      properties: {
        "pedido": {
          name: 'pedido',
          type: 'string'
        },
        "uuid": {
          name: 'uuid',
          type: 'string'
        },
        "odooData": {
          name: 'odooData',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
